import { Location } from '@angular/common';
import { MailRequestEx } from './../models/mailRequest';
import { Router } from '@angular/router';
import { DataService } from './../data.service';
import { Component, OnInit } from '@angular/core';
import { WhatsappRequest } from '../models/whatsappRequest';

@Component({
  selector: 'app-summary-message-progress',
  templateUrl: './summary-message-progress.component.html',
  styleUrls: ['./summary-message-progress.component.scss']
})
export class SummaryMessageProgressComponent implements OnInit {


  private req: WhatsappRequest;
  public errMessage: string;
  constructor(private data: DataService, private router: Router, private location: Location) { }

  ngOnInit(): void {
    this.req = this.data.WhatsappReq;
    this.errMessage = "Sending message, please wait...."
    this.SendWhatsapp();
  }

  SendWhatsapp(): void {
    this.data.request<string>("kiosk/propertysummarywhatsapp",null,"GET").subscribe((e)=>{
      this.location.back();
    },(error)=>{
      /*
      this.errMessage = "Failed to send the message, please try again";
      console.error(error);
      this.delay(3000).then((v) => {
        this.location.back();
      })*/
      this.location.back();

    })
  }

 delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
}
